<script>
import axios from 'axios'
import moment from 'moment'

export default {
  props: {
    links: {
      type: Array,
      default: () => []
    },
    options: {
      type: Object,
      default: function() {
        return {
          name: 'fileinput',
          acceptFormats: '.xls'
        }
      }
    },
    modelkey: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      loader: false,
      localLinks: []
    }
  },

  created() {
    this.localLinks = this.links
  },

  watch: {
    links: {
      handler: function(val) {
        this.localLinks = val
      },
      deep: true
    }
  },

  methods: {
    async uploadFile() {
      this.loader = true
      let self = this
      let files = [...this.$refs.fileinput.files]
      this.$refs.fileinput.value = null
      const allPromise = files.map(async file => {
        const formData = new FormData()
        formData.append('file', file)
        return axios
          .post('/api/core/dms/create', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(response => {
            self.localLinks.push({
              name: file.name,
              link: response.data.fileSignature
            })
          })
      })
      Promise.all(allPromise)
        .then(() => {
          self.$emit('filepick', self.localLinks, this.modelkey)
          this.loader = false
        })
        .catch(err => {
          this.$store.dispatch('directNotification', {
            type: 'error',
            message: 'Error Uploading File',
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
            description: err.message
          })
          this.loader = false
        })
    }
  }
}
</script>

<template>
  <v-card
    style="border-radius: 10px"
    flat
    :class="$vuetify.dark ? 'card-dark ' : 'card-light '"
  >
    <v-card-text>
      <v-progress-linear
        color="accent"
        :indeterminate="true"
        v-show="loader"
      ></v-progress-linear>
      <v-layout align-center justify-start row fill-height wrap>
        <v-flex xs12 lg4 class="pa-3">
          <input
            v-show="false"
            :multiple="options.multiple"
            :name="options.name"
            @change="uploadFile"
            ref="fileinput"
            type="file"
            :accept="options.acceptFormats"
          />
          <v-btn
            :loading="loader"
            :disabled="loader"
            class="text-capitalize"
            @click="$refs.fileinput.click()"
          >
            Upload
            <v-icon right dark>cloud_upload</v-icon>
          </v-btn>
          <br />
          <v-chip v-if="localLinks.length > 1" color="secondary" outline
            >Total documents selected: {{ localLinks.length }}
          </v-chip>
        </v-flex>
        <v-flex xs12 lg8>
          <template v-for="(item, key) in localLinks">
            <v-chip
              style="max-width: 100%"
              color="secondary"
              class="text-truncate"
              outline
              :key="key + 'file_link'"
            >
              <v-avatar>
                <v-icon>attach_file</v-icon>
              </v-avatar>
              <span class="text-truncate">{{ item.name }}</span></v-chip
            >
          </template>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>
